import moment from 'moment-timezone'

export const getStoppageDuration = (stoppageStart: string, stoppageEnd?: string): string => {
  const start = new Date(stoppageStart)
  const end = stoppageEnd ? new Date(stoppageEnd) : new Date()
  const seconds = Math.floor((end.getTime() - start.getTime()) / 1000)
  return isNaN(seconds) || seconds < 0 ? '-' : moment.duration(seconds, 'seconds').humanize()
}
